import { takeLatest } from 'redux-saga/effects'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import { BaselinkerApi } from '@services/BaselinkerApi'

const fetchList = async (_: any, { payload }: Action): Promise<any> => {
  const {
    criteria: { baseLinkerProductId, syncDetailToken, endAt, ...rest },
    limit,
    offset,
  } = payload

  return BaselinkerApi(syncDetailToken)
    .product.productSyncDetail({
      baseLinkerProductId: { in: [baseLinkerProductId] },
      from: endAt?.gte,
      to: endAt?.lt,
      limit,
      offset,
      ...rest,
    })
    .catch((e: any) => {
      const error = String(e?.response?.data?.message || e?.message || e)
      console.error(error)
    })
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield takeLatest(actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
